import { apolloClient } from "@td/ui";
import NURSE_PRACTITIONERS_SEARCH_QUERY from '../queries/nurse_practitioners_search.graphql';
import { mapToProviderToDropdownOption } from '../utils';

const searchNursePractitioners = async (npi, nameSearchString) => {
  const { data: { nursePractitionersSearch } } = await apolloClient.query({
    query: NURSE_PRACTITIONERS_SEARCH_QUERY,
    fetchPolicy: 'network-only',
    variables: {
      npi: npi,
      nameSearchString: nameSearchString
    }
  });

  return nursePractitionersSearch.map(mapToProviderToDropdownOption);
}

export default searchNursePractitioners;
